import group from "./undo_group";
import {find, findIndex} from "../helpers/array";
import {setSpanCss} from "../operations/spans";

export const lockCss = "webix_lock";

export function init(view){
	view.attachEvent("onUndo", (type, row, column, mode) => {
		if (type === "lock") lockCell(view, row, column, !!mode, true);
	});
	view.attachEvent("onCommand", (cm) => {
		if (cm.id === "lock-cell"){
			const firstSel = view.getSelectedId();
			if(firstSel){
				const mode = isCellLocked(view, firstSel.row, firstSel.column);
				group.set(()=>{
					const areas = view._table.getAllSelectAreas();
					for(let name in areas)
						lockCell(view, areas[name].start, areas[name].end, !mode);
				});
			}
		}
	});
}

export function lockCell(view, row, column, mode, silent, pageName, innerCall){
	if (typeof row === "object" && typeof column === "object")
		group.set(()=>{
			const start = row, end = column;
			for (let r = start.row; r <= end.row; r++)
				for (let c = start.column; c <= end.column; c++)
					lockCell(view, r, c, mode, true, pageName, true);
		});
	else{
		mode = mode === false ? false : true;

		const activeSheet = view.getActiveSheet();
		if(!pageName)
			pageName = activeSheet;

		if(pageName != activeSheet){
			const page = find(view._sheets, sheet => sheet.name == pageName);
			if(page){
				const locked = page.content.locked; 
				if(locked){
					const locked = page.content.locked;
					const index = findIndex(locked, cell => cell[0] == row && cell[1] == column);
					if(mode){
						if(index == -1)
							locked.push([row, column]);
					}
					else if(index != -1)
						locked.splice(index, 1);
				}
				else if(!locked && mode)
					page.content.locked = [[row, column]];
			}
		}
		else
			setSpanCss(view, row, column, lockCss, mode);

		const cell = (pageName == activeSheet ? view._mPage : view._mData.getPage(pageName)).getCell(row-1, column-1, true);
		cell.$locked = mode;
	}

	if(!innerCall)
		view.callEvent("onAction", ["lock", { row, column, value: !mode, newValue: mode, page: pageName }]);

	if (!silent)
		view.$$("cells").refresh();
}

export function isCellLocked(view, row, column, page){
	const activeSheet = view.getActiveSheet();
	if(!page)
		page = activeSheet;
	const cell = (page == activeSheet ? view._mPage : view._mData.getPage(page)).getCell(row-1, column-1);
	return cell && cell.$locked;
}

export function load(view, data){
	const locked = data.locked;
	if(locked)
		for(let i = 0; i < locked.length; i++)
			lockCell(view, locked[i][0], locked[i][1], true, true);
}